import { Subscription } from "rxjs"

import { getLogger } from "@/lib/logging.ts"

export type NamedSubscription = { subscription: Subscription, name: string }

export interface Lifetimed {
  lifetime: Lifetime
}

const log = getLogger("Lifetime")

export class Lifetime {
  private _terminated = false

  get terminated() {
    return this._terminated
  }

  private subscriptions: NamedSubscription[] = []

  constructor(parent?: Lifetime, name: string = "onTerminate") {
    parent?.add(() => this.terminate(), name)
  }

  add(subscription: Subscription | (() => void), name: string) {
    const wrapped =
      typeof subscription === "function"
        ? new Subscription(subscription)
        : subscription

    this.subscriptions.push({ subscription: wrapped, name })
  }

  terminate() {
    if (this._terminated) {
      return
    }

    this._terminated = true

    this.subscriptions.forEach(s => {
      log.debug(`Unsubscribing from ${s.name}`)
      s.subscription.unsubscribe()
    })

    this.subscriptions = []
  }
}
